module.exports = __webpack_public_path__ + "static/blog-img15-addcdbc661eecd9eb995122829404908.jpg";